var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Raggruppa_3524",
    "data-name": "Raggruppa 3524",
    transform: "translate(1 0.719)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_61",
    "data-name": "Ellisse 61",
    cx: 9,
    cy: 9,
    r: 9,
    transform: "translate(0 0.281)",
    fill: "none",
    stroke: "#b91f26",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3461",
    "data-name": "Tracciato 3461",
    d: "M9,15l6-6",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#b91f26",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Tracciato_3462",
    "data-name": "Tracciato 3462",
    d: "M15,15,9,9",
    transform: "translate(-3 -3)",
    fill: "none",
    stroke: "#b91f26",
    strokeWidth: 2
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/delete-icon.5d0ecdf1eb1afdb7c58f5817f3819d87.svg";
export { ForwardRef as ReactComponent };